import { render, staticRenderFns } from "./commandbar.vue?vue&type=template&id=74ab4608"
import script from "./commandbar.vue?vue&type=script&lang=js"
export * from "./commandbar.vue?vue&type=script&lang=js"
import style0 from "./commandbar.vue?vue&type=style&index=0&id=74ab4608&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports